import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Layout } from '../components/layout/Layout';
import { B2BShopPage } from '../components/b2b/B2BShopPage';

export const B2BPage: React.FC = () => {
  const { user, isBuyer } = useAuth();

  // Admins get the page wrapped in the standard Layout (sidebar)
  if (user && !isBuyer) {
    return (
      <Layout>
        <B2BShopPage />
      </Layout>
    );
  }

  // Buyers get the standalone page (B2BShopPage has its own nav)
  return <B2BShopPage />;
};
